(function () {
  const details = document.getElementById('HzMobileMenu');
  if (!details) return;

  function setOpen(isOpen) {
    document.body.classList.toggle('hz-menu-open', isOpen);
    document.body.style.overflow = isOpen ? 'hidden' : '';
    const panel = document.getElementById('HzMobileMenuPanel');
    if (panel) panel.setAttribute('aria-hidden', isOpen ? 'false' : 'true');
  }

  details.addEventListener('toggle', () => setOpen(details.open));

  document.addEventListener('click', (event) => {
    if (details.open && event.target.closest('[data-hz-mobile-menu-close]')) {
      details.removeAttribute('open');
    }
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && details.open) {
      details.removeAttribute('open');
      details.querySelector('summary')?.focus();
    }
  });
})();
